export const MENUITEMS = [
  {
    menutitle: "Bookings",
    menucontent: "Bookings",
    Items: [
     

     { path: `${process.env.PUBLIC_URL}/eservices/bookings`, icon: "others", type: "link", title: "Make a Booking" },
	 
    ],
  },

  {
    menutitle: "Renewals",
    menucontent: "Renewals",
    Items: [
      
	   { path: `${process.env.PUBLIC_URL}/eservices/renewals`, icon: "ecommerce", type: "link", title: "Apply for Renewal" },
     
      
    ],
  },

  {
    menutitle: "Duplicates",
    menucontent: "Apply for a Copy",
    Items: [
      {
        icon: "faq",
        badge2: true,
        active: true,
        path: `${process.env.PUBLIC_URL}/eservices/duplicates`,
        title: "Apply for a Copy",
        type: "link",
      },
	       
      
    ],
  },

      
  {
    menutitle: "New Applications",
    menucontent: "Make New Application",
    Items: [
      {
        icon: "job-search",
        badge2: true,
        active: false,
        path: `${process.env.PUBLIC_URL}/eservices/NewApplications`,
        title: "Make New Application",
        type: "link",
      },
	       
      
    ],
  },
  
  
    
];
